import React from 'react';
import ContactsContainer from './contacts/ContactsContainer';
import { Switch, Redirect } from 'react-router-dom';
import ProtectedRoute from '../utils/ProtectedRoute';
import routes from '../utils/commonVariables/routes';
import { ProviderAccountInformation } from '../contexts/AccountInformationContext';
import { ProviderPaymentTerms } from '../contexts/PaymentTermsContext';
import { ProviderSettings } from '../contexts/SettingsContext';
import AccountInformationContainer from './accountInformation/AccountInformationContainer';
import PaymentContainer from './payment/PaymentContainer';
import SettingsContainer from './settings/SettingsContainer';
import LateralMenuBasic from '../layout/LateralMenu/LateralMenuBasic';
import { getProfileMenu } from '../utils/menusData';
import { useAppConfigurationSections } from '../contexts/AppConfigurationContext';
import {
    AppSections,
    AppSectionsProfile,
} from '../types/appConfiguration/appConfigTypes';

const AccountContainer = props => {
    const { match } = props;
    const { profile, isProfileSectionVisible } = useAppConfigurationSections();

    const profileRedirect = () => {
        const { pages } = profile;
        if (pages[AppSectionsProfile.ACCOUNT])
            return match.path + routes.accountInfo;
        if (pages[AppSectionsProfile.PAYMENT])
            return match.path + routes.paymentTerms;
        if (pages[AppSectionsProfile.CONTACTS])
            return match.path + routes.profileContacts;
        if (pages[AppSectionsProfile.SETTINGS])
            return match.path + routes.settings;
        return routes.landingPrivate;
    };

    let profileMenuItems = getProfileMenu(
        isProfileSectionVisible,
        profile.pages
    );

    profileMenuItems = profileMenuItems.filter(item => item?.visibilityKey);

    return (
        <div className='account-container'>
            <LateralMenuBasic list={profileMenuItems} />
            <section
                className={`owner-portal__content-container account-section`}
            >
                <Switch>
                    <ProtectedRoute
                        path={match.path + routes.accountInfo}
                        render={() => (
                            <ProviderAccountInformation>
                                <AccountInformationContainer />
                            </ProviderAccountInformation>
                        )}
                        section={AppSections.PROFILE}
                        page={AppSectionsProfile.ACCOUNT}
                    />
                    <ProtectedRoute
                        path={match.path + routes.profileContacts}
                        render={() => (
                            <ProviderAccountInformation>
                                <ContactsContainer />
                            </ProviderAccountInformation>
                        )}
                        section={AppSections.PROFILE}
                        page={AppSectionsProfile.CONTACTS}
                    />
                    <ProtectedRoute
                        path={match.path + routes.paymentTerms}
                        render={() => (
                            <ProviderPaymentTerms>
                                <PaymentContainer />
                            </ProviderPaymentTerms>
                        )}
                        section={AppSections.PROFILE}
                        page={AppSectionsProfile.PAYMENT}
                    />
                    <ProtectedRoute
                        path={match.path + routes.settings}
                        render={() => (
                            <ProviderSettings>
                                <SettingsContainer />
                            </ProviderSettings>
                        )}
                        section={AppSections.PROFILE}
                        page={AppSectionsProfile.SETTINGS}
                    />
                    <ProtectedRoute
                        path={match.path}
                        render={() => <Redirect to={profileRedirect()} />}
                        section={AppSections.PROFILE}
                    />
                </Switch>
            </section>
        </div>
    );
};

export default AccountContainer;
